export default "/fonts/vendor/@quasar/extras/fontawesome-v6/fa-v4compatibility.woff2?ea8f94e1d22e0d35ccd46ea889dbf038";